import { BaseActions, ActionMenuItem } from "../../components/action-menu/ActionMenuItem";
import i18n from "../../services/localization-service/i18n";
import { AddIcon } from "../../components/action-menu/ActionMenuIcons";


export enum AlarmScheduleListActionEnum {
    Add = 'add',
    Edit = 'edit',
    Delete = 'delete',
}

export type AlarmScheduleListActionItem = {
    action: AlarmScheduleListActionEnum | BaseActions
} & ActionMenuItem;



export const actionItems: AlarmScheduleListActionItem[] = [{
    label: i18n.t("buttons.addAlarmSchedule"),
    icon: AddIcon,
    action: AlarmScheduleListActionEnum.Add,
    order: 0
}];




